export enum NearNeighborhoodEnum {
	INCLUDE = 'S',
	NOT_INCLUDE = 'N',
}
